import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CheckIcon = () => {
  return <FontAwesomeIcon icon="fa-solid fa-check" />;
};

export default CheckIcon;
